/**
 * 数数埋点统一封装（参考 app-h5/base/js/src/ta.ts，2026-06-08）
 * 用法：this.$track.trackPageView('page_withdraw')
 */
import ta from "thinkingdata-browser";

const isProd = process.env.NODE_ENV === "production";

const TA_APP_ID =
  process.env.VUE_APP_TD_APP_ID ||
  (isProd
    ? "c112a62667f043a2ad36016bf1cc2d2d"
    : "c8eb5b84145340b4b3c14d12aa22f8e4");

const TA_SERVER_URL =
  process.env.VUE_APP_TD_SERVER_URL || "https://shushuh5.laylachat.com";

/** 与 app-h5 保持一致的事件名 */
export const TRACK_EVENTS = {
  PAGE_VIEW_START: "h5_page_view_start",
};

/** 页面名称常量，其他页面按需补充 */
export const PAGE_NAME = {
  WITHDRAW: "page_withdraw",
};

let inited = false;

function ensureInit() {
  if (inited) return;
  ta.init({
    appId: TA_APP_ID,
    serverUrl: TA_SERVER_URL,
    showLog: !isProd,
    autoTrack: {
      pageShow: false,
      pageHide: false,
    },
  });
  if (typeof window !== "undefined") {
    window.XDFTTA = ta;
  }
  inited = true;
  loginFromStorage();
}

function loginFromStorage() {
  try {
    login(JSON.parse(localStorage.getItem("data") || "{}"));
  } catch (e) {
    /* ignore */
  }
}

/** 用户登录后绑定账号（getUserInfo 回调后调用） */
export function login(userInfo) {
  if (!userInfo) return;
  ensureInit();
  const uid = userInfo.uid || userInfo.userId;
  if (uid && userInfo.token) {
    ta.login(String(uid));
  }
}

/** 自定义事件上报 */
export function track(eventName, properties = {}) {
  if (!eventName) return;
  ensureInit();
  ta.track(eventName, properties);
}

/** H5 页面曝光：h5_page_view_start + page_name */
export function trackPageView(pageName, properties = {}) {
  track(TRACK_EVENTS.PAGE_VIEW_START, {
    page_name: pageName,
    ...properties,
  });
}

export function init() {
  ensureInit();
}

export default {
  init,
  login,
  track,
  trackPageView,
  PAGE_NAME,
  TRACK_EVENTS,
};
